import { MILESTONE_TYPES } from 'resources/milestone/milestone.constants';
import { DEAL_STAGES } from 'resources/deal/deal.constants';

export const LISTEDKIT_TYPES = {
  BUYER_GHOST: 'buyer_ghost',
  SELLER_GHOST: 'seller_ghost',
  BUYER_UNDER_CONTRACT: 'buyer_under_contract',
  BUYER_PRE_CONTRACT: 'buyer_pre_contract',
  SELLER_UNDER_CONTRACT: 'seller_under_contract',
  SELLER_PRE_CONTRACT: 'seller_pre_contract',
  BLANK: 'blank',
};

export const SELLER_LISTEDKIT_TYPES = [LISTEDKIT_TYPES.SELLER_PRE_CONTRACT, LISTEDKIT_TYPES.SELLER_UNDER_CONTRACT];
export const BUYER_LISTEDKIT_TYPES = [LISTEDKIT_TYPES.BUYER_PRE_CONTRACT, LISTEDKIT_TYPES.BUYER_UNDER_CONTRACT];

export const ONBOARDING_TASK_CONTENT = {
  COMPLETE_HOME_SEARCH_FORM: 'Complete Home Search Form',
  INDICATE_UPGRADES_TO_HOME: 'Indicate upgrades to home',
};

export const LISTED_KIT_TYPE_TO_MILESTONE_TYPES = {
  [LISTEDKIT_TYPES.BUYER_PRE_CONTRACT]: MILESTONE_TYPES.PRE_CONTRACT,
  [LISTEDKIT_TYPES.SELLER_PRE_CONTRACT]: MILESTONE_TYPES.PRE_CONTRACT,
  [LISTEDKIT_TYPES.BUYER_UNDER_CONTRACT]: MILESTONE_TYPES.UNDER_CONTRACT,
  [LISTEDKIT_TYPES.SELLER_UNDER_CONTRACT]: MILESTONE_TYPES.UNDER_CONTRACT,
};

export const LISTED_KIT_TYPE_TO_STATUS = {
  [LISTEDKIT_TYPES.BUYER_PRE_CONTRACT]: DEAL_STAGES.PRE_CONTRACT,
  [LISTEDKIT_TYPES.SELLER_PRE_CONTRACT]: DEAL_STAGES.PRE_CONTRACT,
  [LISTEDKIT_TYPES.BUYER_UNDER_CONTRACT]: DEAL_STAGES.UNDER_CONTRACT,
  [LISTEDKIT_TYPES.SELLER_UNDER_CONTRACT]: DEAL_STAGES.UNDER_CONTRACT,
};

export const HOME_LISTED_MILESTONE_NAME = 'Home Listed';

export const DEFAULT_NAMES = {
  BLANK: 'Blank',
  BUYER_PRE_CONTRACT: 'Buyer Pre-Contract',
  BUYER_UNDER_CONTRACT: 'Buyer Under Contract',
  LISTING_PRE_CONTRACT: 'Listing Pre-Contract',
  LISTING_UNDER_CONTRACT: 'Listing Under Contract',
};
